//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{
      showA: '-1',
      productList:[
        {
          title: '经典配置供您选择',
          subTil: ' 基于云计算的虚拟主机服务',
          content: '快速选购官方推荐最合适的搭配套餐提供4款经典组合产品供用户选择，详细PC版查看',
        },
        {
          title: 'DIY选购，高度自由',
          subTil: '极速稳定高弹性的计算服务',
          content: '高度自主、根据需求自主选配，详细PC版查看',
        },
        {
          title: '阿贝云云服务器优势',
          subTil: '提供五星级的域名注册服务',
          content: '（1）系统盘、数据盘全部采用高性能SSD固态硬盘部署，吞吐量达千兆每秒，随机读写2万IOPS，完美支持大文件高吞吐高IO并发。（2）阿贝云云平台采用三副本存储，即用户所有数据均在集群中存放三份，彻底规避单点故障，保证业务高可用。（3）提供全盘备份功能，每次可备份整块磁盘数据，保障数据更完整更安全。（4）紧急情况无法连接到远程服务器，可以直接通过web控制台操作检查',
        },
      ]
    }
  },
  components: {
    CFooter
  },
  methods:{
    listDown(d) {
      if(this.showA == d) {
        this.showA = '-1'
      } else {
        this.showA = d
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/product/vps.vue